import { FORM_STEP_10_STATE, FORM_STEP_11_STATE, FORM_STEP_1_STATE, FORM_STEP_2_STATE, FORM_STEP_3_STATE, FORM_STEP_4_STATE, FORM_STEP_5_STATE, FORM_STEP_6_STATE, FORM_STEP_7_STATE, FORM_STEP_8_STATE, FORM_STEP_9_STATE, STEP_STATE_NOT_SUBMITTED } from "../constants";

export const getFormValue = function (key, collection) {

    for (let i = 0; i < collection.length; i++) {
        if(collection[i].key === key) return collection[i].value;
    }

    return null;
}

export const getFormStepStates = function (formFields) {
    let steps = {
        step1: STEP_STATE_NOT_SUBMITTED,
        step2: STEP_STATE_NOT_SUBMITTED,
        step3: STEP_STATE_NOT_SUBMITTED,
        step4: STEP_STATE_NOT_SUBMITTED,
        step5: STEP_STATE_NOT_SUBMITTED,
        step6: STEP_STATE_NOT_SUBMITTED,
        step7: STEP_STATE_NOT_SUBMITTED,
        step8: STEP_STATE_NOT_SUBMITTED,
        step9: STEP_STATE_NOT_SUBMITTED,
        step10: STEP_STATE_NOT_SUBMITTED,
        step11: STEP_STATE_NOT_SUBMITTED
    };

    for (let i = 0; i < formFields.length; i++) {
        if(formFields[i].key === FORM_STEP_1_STATE) steps.step1 = formFields[i].value;
        if(formFields[i].key === FORM_STEP_2_STATE) steps.step2 = formFields[i].value;
        if(formFields[i].key === FORM_STEP_3_STATE) steps.step3 = formFields[i].value;
        if(formFields[i].key === FORM_STEP_4_STATE) steps.step4 = formFields[i].value;
        if(formFields[i].key === FORM_STEP_5_STATE) steps.step5 = formFields[i].value;
        if(formFields[i].key === FORM_STEP_6_STATE) steps.step6 = formFields[i].value;
        if(formFields[i].key === FORM_STEP_7_STATE) steps.step7 = formFields[i].value;
        if(formFields[i].key === FORM_STEP_8_STATE) steps.step8 = formFields[i].value;
        if(formFields[i].key === FORM_STEP_9_STATE) steps.step9 = formFields[i].value;
        if(formFields[i].key === FORM_STEP_10_STATE) steps.step10 = formFields[i].value;
        if(formFields[i].key === FORM_STEP_11_STATE) steps.step11 = formFields[i].value;
    }
}